<template>
  <v-container
    class="pa-4"
  >
    <v-card>
      <v-list
        two-line
      >
        <template
          v-for="(item, i) in items"
        >
          <v-list-item
            :key="`item-${i}`"
            @click="item.onClick"
          >
            <v-list-item-avatar>
              <v-icon>
                {{ item.icon }}
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-icon>
                {{ item.actionIcon }}
              </v-icon>
            </v-list-item-action>
          </v-list-item>

          <v-divider
            v-if="i < items.length - 1"
            :key="`divider-${i}`"
          />
        </template>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    items() {
      return [
        {
          icon: 'model_training',
          title: 'Ilmiannot',
          actionIcon: 'keyboard_arrow_right',
          onClick: () => this.$router.push('/admin/ilmiannot/kuvat'), // eslint-disable-line
        },
        {
          icon: 'show_chart',
          title: 'Tilastot',
          actionIcon: 'keyboard_arrow_right',
          onClick: () => this.$router.push('/admin/tilastot'), // eslint-disable-line
        },
      ];
    },
  },
};
</script>
